const nav = {
    "nav.Home": "Ana Sayfa",
    "nav.Test": "Test",
    "nav.gettingStarted": "Başlangıç",
};

export default nav;